export default __webpack_public_path__ + "static/media/glasses.ab10e8fd.jpg";